export default [
  // Causes TypeError: Cannot read property 'config' of undefined (Most recent call first)
  // https://rollbar.com/envato/market-shopfront/items/237800/?item_page=0&#traceback
  // Seems that error is coming from malware software installed on users computers
  // https://malwaretips.com/blogs/remove-s3-amazonaws-com/
  's3.amazonaws.com'
]
